//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, T } from "../../utils/MT";

export default function ProductInfo(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate.push(`/product/detail/:` + props.i);
    };

    return (
        // 배송지 정보
        <>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>배송지정보</MyPageTitle>
            </MyPageTitleBox>

            <UserInfoBoxWrap>
                <thead>
                    <tr>
                        <InfoTitle>주문자</InfoTitle>
                        <InfoContent>최신도</InfoContent>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <InfoTitle>전화번호</InfoTitle>
                        <InfoContent></InfoContent>
                    </tr>
                    <tr>
                        <InfoTitle>휴대폰번호</InfoTitle>
                        <InfoContent>010-1234-5678</InfoContent>
                    </tr>
                    <tr>
                        <InfoTitle>주소</InfoTitle>
                        <InfoContent>서울 서초구 강남대로53길 8 8층</InfoContent>
                    </tr>
                    <tr>
                        <InfoTitle>배송요청사항</InfoTitle>
                        <InfoContent>부재시 전화 또는 문자 주세요.</InfoContent>
                    </tr>
                </tbody>
            </UserInfoBoxWrap>
        </>
    );
}

const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
// 구매자정보
const UserInfoBoxWrap = styled.table`
    width: 100%;
    height: calc(100vw * (240 / 1920));
    margin-top: calc(100vw * (20 / 1920));

    border-top: 1px solid #222222;
    border-bottom: 1px solid #dddddd;

    & tr {
        border-bottom: 1px solid #dddddd;
    }

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (240 / 1300));
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(240)};
        margin-top: ${M(20)};

        & tr:nth-child(n + 3) td {
            padding: ${M(35)} ${M(13)};
        }
    }
`;
const InfoTitle = styled.th`
    width: calc(100vw * (180 / 1920));
    padding: calc(100vw * (21 / 1920)) 0;
    font-size: calc(100vw * (15 / 1920));

    border-right: 1px solid #dddddd;
    text-align: center;
    background: #fafafa;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (180 / 1300));
        padding: calc(100vw * (21 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(120)};
        padding: ${M(13)};
        font-size: ${M(14)};
    }
`;
const InfoContent = styled.td`
    padding: calc(100vw * (20 / 1920)) calc(100vw * (40 / 1920));
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) calc(100vw * (40 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(13)} ${M(15)};
        font-size: ${M(14)};
    }
`;
